import type { useTranslations } from "use-intl";

export const USE_CASE_TONES: Record<string, string> = {
  extract_kg: "bg-[var(--primary)]",
  embedding: "bg-[var(--success)]",
  vision: "bg-[var(--warning)]",
  transcription: "bg-[var(--purple)]",
  transcription_refine: "bg-[var(--pink)]",
  chat: "bg-[var(--destructive)]",
  tool_use: "bg-[var(--muted-foreground)]",
  image_gen: "bg-[var(--primary)]",
  video_gen: "bg-[var(--warning)]",
  tts: "bg-[var(--purple)]",
};

export function formatMoney(value: number) {
  if (value > 0 && value < 0.0001) return "<$0.0001";
  return `$${value.toFixed(4)}`;
}

export function formatUseCase(t: ReturnType<typeof useTranslations>, useCase: string) {
  return t(`use_case.${useCase}` as never);
}
